const UserInfoStyle = {
  AccordionHeader: {
    width: '100%',

    fontFamily: 'dana-bold',
    fontSize: '12px',
    textAlign: 'center',
    // color: '#753CBE',
  },
  AccordionTitle: {
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '18px',
    textAign: 'center',
    color: '#707070',
  },
  AccordionValue: {
    fontFamily: 'dana-bold',
    fontSize: '12px',
    textAlign: 'right',
    color: 'rgba(117, 60, 190, 0.9)',
  },
  EditButton: {
    background: '#F4F4F4 !important',
    border: ' 1px solid #FFFFFF !important',
    boxShadow:
      '-2px -2px 4px #FFFFFF, 4px 4px 15px rgba(0, 0, 0, 0.08) !important',
    borderRadius: '98px !important',

    fontFamily: 'dana-bold',
    fontSize: '10px !important',
    textAlign: 'center',
    margin: '25px auto 21px !important',
    width: '126px',
    height: '30px',
    color: '#3CC0C3 !important',
  },
  mainAccHeader: {
    width: '100%',

    fontFamily: 'dana-bold',
    fontSize: '16px',
    textAlign: 'center',
    color: '#753CBE',
  },

  subAccHeader: {
    fontWeight: '400',
    fontSize: '14px',
    textAlign: 'center',
    color: '#753CBE',
  },
  subAccHeaderRed: {
    fontFamily: 'dana-bold',
    fontSize: '14px',
    textAlign: 'center',
    color: '#D81D5D',
  },
  centerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default UserInfoStyle;
